import {fonts} from './fonts'

const textFontSize = {
  titleXS: fonts.size.xs,
  titleS: fonts.size.sm,
  titleM: fonts.size.md,
  titleL: fonts.size.lg,
  titleXL: fonts.size.xl,
  title2XL: fonts.size.xxl,
  title3XL: fonts.size['3xl'],
  title4XL: fonts.size['4xl'],
  title5XL: fonts.size['5xl'],
  bodyXS: fonts.size.xs,
  bodyS: fonts.size.sm,
  bodyM: fonts.size.md,
  bodyL: fonts.size.lg,
  labelXS: fonts.size.xs,
  labelS: fonts.size.sm,
  labelM: fonts.size.md
}

type TextFontSize = typeof textFontSize
type TextFontSizeKeys = keyof TextFontSize

const textLineHeight = {
  titleXS: fonts.lineHeight.xxs,
  titleS: fonts.lineHeight.xs,
  titleM: fonts.lineHeight.md,
  titleL: fonts.lineHeight.xl,
  titleXL: fonts.lineHeight.xxl,
  title2XL: fonts.lineHeight['3xl'],
  title3XL: fonts.lineHeight['4xl'],
  title4XL: fonts.lineHeight['5xl'],
  title5XL: fonts.lineHeight['6xl'],
  bodyXS: fonts.lineHeight.xxs,
  bodyS: fonts.lineHeight.sm,
  bodyM: fonts.lineHeight.lg,
  bodyL: fonts.lineHeight.xl,
  labelXS: fonts.lineHeight.xxs,
  labelS: fonts.lineHeight.xs,
  labelM: fonts.lineHeight.md
}

const makeText = (type: TextFontSizeKeys) => {
  const fontSize = textFontSize[type]
  const fontWeight = `var(--textFontWeight-${type})`
  const lineHeight = textLineHeight[type]
  const letterSpacing = `var(--letterSpacingAdjust-${type})`

  const styles = {
    fontSize,
    lineHeight,
    fontWeight,
    letterSpacing
  }

  return styles
}

export const typography = {
  titleXS: makeText('titleXS'),
  titleS: makeText('titleS'),
  titleM: makeText('titleM'),
  titleL: makeText('titleL'),
  titleXL: makeText('titleXL'),
  title2XL: makeText('title2XL'),
  title3XL: makeText('title3XL'),
  title4XL: makeText('title4XL'),
  title5XL: makeText('title5XL'),
  bodyXS: makeText('bodyXS'),
  bodyS: makeText('bodyS'),
  bodyM: makeText('bodyM'),
  bodyL: makeText('bodyL'),
  labelXS: makeText('labelXS'),
  labelS: makeText('labelS'),
  labelM: makeText('labelM')
}
